import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InstagramAmbassadorPostDetails.graphql';
import { Query, QueryinstagramAmbassadorPostDetailsArgs } from '../../__generated__/globalTypes';

export const useInstagramAmbassadorPostDetailsQuery = (
  options?: QueryHookOptions<Query, QueryinstagramAmbassadorPostDetailsArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinstagramAmbassadorPostDetailsArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInstagramAmbassadorPostDetailsLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinstagramAmbassadorPostDetailsArgs>
): QueryResult<Query, QueryinstagramAmbassadorPostDetailsArgs> & {
  getInstagramAmbassadorPostDetails: LazyQueryExecFunction<Query, QueryinstagramAmbassadorPostDetailsArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInstagramAmbassadorPostDetails, result] = useLazyQuery<Query, QueryinstagramAmbassadorPostDetailsArgs>(
    QUERY,
    {
      onError: (error) => {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      },
      ...options
    }
  );

  return { getInstagramAmbassadorPostDetails, ...result };
};

export const useInstagramAmbassadorPostDetailsPromiseQuery = () => {
  const client = useApolloClient();

  const getInstagramAmbassadorPostDetails = useCallback(
    (options?: Omit<QueryOptions<QueryinstagramAmbassadorPostDetailsArgs, Query>, 'query'>) =>
      client.query<Query, QueryinstagramAmbassadorPostDetailsArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInstagramAmbassadorPostDetails };
};
// Suspense Query Hooks
export const useInstagramAmbassadorPostDetailsSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinstagramAmbassadorPostDetailsArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinstagramAmbassadorPostDetailsArgs>(QUERY, {
    ...options
  });

  return result;
};
